/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicBookingPathParameters } from 'api/actions/get-public-booking/get-public-booking-path-parameters';
import { GetPublicBookingResponse } from 'api/actions/get-public-booking/get-public-booking-response';

type GetPublicBookingQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicBooking action.
 */
export const getPublicBookingActionPath = new SweetPath<keyof GetPublicBookingPathParameters>(
  '/reservations/public/bookings/{token}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetPublicBooking actions.
 */
export default function createGetPublicBookingAction(axios: AxiosInstance) {
  return function getPublicBookingAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicBookingPathParameters;
    query?: GetPublicBookingQueryParameters;
  }) {
    const path = getPublicBookingActionPath.insert(parameters);

    return axios.get<GetPublicBookingResponse, GetPublicBookingResponse>(path, { params: query, headers });
  };
}
